import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FcBusinessman } from "react-icons/fc";
import axios from "axios";

const History = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const location = useLocation();
  const { uniqueIds, location: scannedLocation } = location.state || {}; // Handle undefined case

  console.log("Received Data:", uniqueIds, scannedLocation);
  console.log("data", data);
  useEffect(() => {
    console.log("Scanned ID:", uniqueIds);
    if (uniqueIds) {
      scanDetails(); // Call the API if uniqueIds exist
    }
  }, [uniqueIds]); // Ensure API is called when uniqueIds change

  const scanDetails = () => {
    const data = {
      unique_id: uniqueIds,
      location: scannedLocation?.address,
      area: scannedLocation?.area,
      city: scannedLocation?.city,
      state: scannedLocation?.state,
      country: scannedLocation?.country,
      pincode: scannedLocation?.pincode,
    };

    axios
      .post(`${process.env.REACT_APP_BASE_URL}get_new_unique_scan_right`, data)
      .then((response) => {
        console.log("Scan Response:", response);
        setData(response?.data?.data?.table_data || []);
        // setData(response?.data?.data?.scan_history || []);
      })
      .catch((error) => {
        console.log("Error:", error);
        if (error?.response?.data) {
          const errorMessage = error.response.data.msg;
          console.error("Error Message:", errorMessage);
        }
      });
  };

  return (
    <div>
      <div>
        <div className="page_wrapper">
          <div id="preloader">
            <div id="loader" />
          </div>
          <header>
            <div className="container">
              <nav className="navbar navbar-expand-lg">
                <Link to={"/"} className="navbar-brand">
                  <img src="images/Logosmall.png" alt="image" />
                </Link>
                <button
                  className="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon">
                    <div className="toggle-wrap">
                      <span className="toggle-bar" />
                    </div>
                  </span>
                </button>
                <div
                  className="collapse navbar-collapse"
                  id="navbarSupportedContent">
                  <ul className="navbar-nav ml-auto">
                    <li className="nav-item has_dropdown">
                      <Link to={"/"} className="nav-link">
                        Home
                      </Link>
                    </li>

                    <li className="nav-item">
                      <a className="nav-link" href="#how_it_work">
                        How it works
                      </a>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </header>
          <div
            style={{
              marginTop: "20px",
              marginLeft: "50px",
              marginRight: "50px",
            }}>
            <h3
              className="mb-4 "
              style={{
                fontFamily: "Arial, sans-serif",
                fontWeight: "bold",
                fontSize: "25px",
              }}>
              Scan History <FcBusinessman />{" "}
            </h3>
            <div className="table-responsive w-100">
              <table className="table table-bordered table-hover">
                <thead className="thead-dark">
                  <tr>
                    <th>SR.</th>
                    <th>Name</th>
                    <th>Phone No.</th>
                    <th>Date</th>
                    <th>Brand</th>
                    <th>Product</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.batch_name || "N/A"}</td>
                        <td>{item.brand || "N/A"}</td>
                        <td>{item.product || "N/A"}</td>
                        <td>{item.price || "N/A"}</td>
                        <td>{item.scan_count || "0"}</td>
                        <td className="text-center">
                          <button
                            onClick={() => setIsModalOpen(true)}
                            className="btn btn-primary btn-sm mx-1">
                            <i className="fas fa-eye"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="purple_backdrop" />
          </div>
        </div>
      </div>
      {/* Second Modal - Opens on Left Scroll */}
      {isModalOpen && (
        <div className="modal show d-block" style={{ width: "100%" }}>
          <div
            style={{ width: "70%", margin: "auto" }}
            className="modal-dialog"
            role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  onClick={() => setIsModalOpen(false)}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="w-100 d-flex align-center justify-content-center mb-4">
                  <img width={120} src="images/Logosmall.png" alt="Logo" />
                </div>
                <div className="container-fluid mt-4">
                  <div className="row w-100 d-flex align-items-center justify-content-center">
                    <div className="col-6 col-md-6 d-flex justify-content-center">
                      <img
                        width={100}
                        className="rounded mb-4"
                        src="images/abt_02.png"
                        alt="Logo"
                      />
                    </div>
                    <div className="col-6 col-md-6 d-flex justify-content-center">
                      <p>
                        <strong>Jack Sparrow</strong>
                      </p>
                    </div>
                  </div>
                  <div className="row w-100 d-flex align-items-center justify-content-center">
                    <div className="col-6 col-md-6 d-flex justify-content-center">
                      <p>
                        <strong>Brand :</strong>
                      </p>
                    </div>
                    <div className="col-6 col-md-6 d-flex justify-content-center">
                      <p>
                        <strong>Polo</strong>
                      </p>
                    </div>
                  </div>
                  <div className="row w-100 d-flex align-items-center justify-content-center">
                    <div className="col-6 col-md-6 d-flex justify-content-center">
                      <p>
                        <strong>ALFHA4002:</strong>
                      </p>
                    </div>
                    <div className="col-6 col-md-6 d-flex justify-content-center">
                      <p>
                        <strong>1600</strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default History;
